"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _classnames = _interopRequireDefault(require("classnames"));
var _sharedVariables = require("../../shared-variables");
require("./animator.css");
var _excluded = ["animation", "children", "className", "entranceDelay"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * An animation utility for preset entrance/exit animations using React Transition Group.
 * If rendering more than one child, or toggling the state of a single child,
 * be sure each child has a unique key.
 */
var Animator = function Animator(_ref) {
  var _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'fadeGrow' : _ref$animation,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$entranceDelay = _ref.entranceDelay,
    entranceDelay = _ref$entranceDelay === void 0 ? 0 : _ref$entranceDelay,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, _extends({
    appear: true,
    component: null
  }, otherProps), _react.Children.map(children, function (child) {
    var animatorRef = /*#__PURE__*/(0, _react.createRef)();
    if (! /*#__PURE__*/(0, _react.isValidElement)(child)) {
      return;
    }
    var childKey = child === null || child === void 0 ? void 0 : child.key;
    return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
      classNames: (0, _classnames["default"])(className, "sb-animator-".concat(animation)),
      key: childKey,
      nodeRef: animatorRef,
      timeout: {
        appear: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration) + entranceDelay,
        enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration) + entranceDelay,
        exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration)
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: animatorRef,
      style: {
        transitionDelay: "".concat(entranceDelay, "ms")
      }
    }, child));
  }));
};
Animator.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The name of the animation to be applied to children. Defaults to 'fadeGrow'.
   */
  animation: _propTypes["default"].oneOf(['fade', 'grow', 'fadeGrow']),
  /** The element to be animated. Make sure each child has a unique key if there are multiple children. */
  children: _propTypes["default"].any,
  /**
   * Value in milliseconds before the transition animation begins. May affect exit transition.
   */
  entranceDelay: _propTypes["default"].number
} : {};
Animator.displayName = 'Animator';
var _default = exports["default"] = Animator;